import { Phone, MapPin, Clock, MessageCircle } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaSection } from "@/components/CtaSection";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { COMPANY, waLink } from "@/data/company";
import { breadcrumbSchema, localBusinessSchema } from "@/lib/schema";

export default function ContatoPage() {
  const crumbs = [
    { name: "Início", url: "/" },
    { name: "Contato", url: "/contato" },
  ];
  return (
    <main className="max-w-7xl mx-auto px-4 md:px-8" data-testid="contato-page">
      <Seo
        title="Contato | Desentupidora em Guarulhos 24h — (11) 97195-0197"
        description="Fale com a Desentupidora em Guarulhos: WhatsApp e telefone (11) 97195-0197, atendimento 24 horas em todos os bairros. R. Marret, 412 - Guarulhos, SP."
        path="/contato"
        jsonLd={[breadcrumbSchema(crumbs), localBusinessSchema()]}
      />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-brand-dark uppercase tracking-tight py-4">
        Fale com a gente <span className="text-brand-red">agora</span>
      </h1>
      <p className="text-gray-600 text-sm md:text-base max-w-3xl mb-10">
        Atendimento humano 24 horas por dia. O caminho mais rápido é o WhatsApp: descreva o problema, envie fotos se quiser e receba o orçamento fechado em minutos.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-8">
        <a href={waLink()} target="_blank" rel="noopener noreferrer" className="bg-brand-green hover:bg-brand-greenHover text-white rounded-2xl p-8 transition-colors group" data-testid="contato-whatsapp-card">
          <WhatsAppIcon className="w-8 h-8 mb-4" />
          <h2 className="font-heading font-black text-xl uppercase">Chamar no WhatsApp</h2>
          <p className="text-white/90 text-sm mt-2">Resposta em segundos, com orçamento fechado antes da visita.</p>
          <p className="font-heading font-black text-2xl mt-4 group-hover:scale-105 transition-transform origin-left">{COMPANY.telefone}</p>
        </a>
        <a href={`tel:${COMPANY.telefoneRaw}`} className="bg-brand-red hover:bg-brand-redDark text-white rounded-2xl p-8 transition-colors group" data-testid="contato-phone-card">
          <Phone size={30} className="mb-4" />
          <h2 className="font-heading font-black text-xl uppercase">Ligação direta</h2>
          <p className="text-white/90 text-sm mt-2">Prefere falar? Ligue e fale direto com um técnico de plantão.</p>
          <p className="font-heading font-black text-2xl mt-4 group-hover:scale-105 transition-transform origin-left">{COMPANY.telefone}</p>
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-8">
        <div className="bg-brand-light rounded-2xl p-8">
          <MapPin size={26} className="text-brand-red mb-3" />
          <h2 className="font-heading font-bold text-lg text-brand-dark uppercase">Endereço</h2>
          <p className="text-gray-600 text-sm mt-2">{COMPANY.endereco} — Guarulhos, SP</p>
          <p className="text-gray-500 text-xs mt-1">CNPJ: {COMPANY.cnpj}</p>
        </div>
        <div className="bg-brand-light rounded-2xl p-8">
          <Clock size={26} className="text-brand-red mb-3" />
          <h2 className="font-heading font-bold text-lg text-brand-dark uppercase">Horário de atendimento</h2>
          <p className="text-gray-600 text-sm mt-2">{COMPANY.horario}.</p>
          <p className="text-gray-500 text-xs mt-1">Emergências têm prioridade máxima, a qualquer hora.</p>
        </div>
      </div>

      <div className="rounded-2xl overflow-hidden shadow-md mb-10" data-testid="contato-mapa">
        <iframe
          title="Mapa da Desentupidora em Guarulhos"
          src="https://www.google.com/maps?q=R.+Marret,+412,+Guarulhos,+SP&output=embed"
          width="100%"
          height="380"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      <CtaSection titulo="Emergência agora?" texto="Não perca tempo: chame no WhatsApp e nossa equipe mais próxima sai imediatamente para o seu endereço." />
    </main>
  );
}
